export const environment = {
  production: true,
  apiEndpoint: '/api/v1',
  oldAppPath: '/app/#',
  staticPath: '/ng/'
};



// WEBPACK FOOTER //
// /srv/projects/jsapp/src/environments/environment.ts